import { isIOS } from 'react-device-detect';

import { useClientHasRendered } from '@domain/session/useClientHasRendered';

export const useIsIOS = (): boolean => {
  const clientHasRendered = useClientHasRendered();
  return clientHasRendered && isIOS;
};
